module.exports = __webpack_public_path__ + "static/media/a8.e136d80.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengxiaoyue/a8.mp3
// module id = FnNM
// module chunks = 0